import { ColoursObj, Icon } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { CardText } from '../subComponents/cardText'
import { useObjectContext } from '../providers/objectProvider'

interface IParkingHeaderProps {
    parking_name: string
    
}
export const ParkingHeader = ({ parking_name }: IParkingHeaderProps) => {
    const { past } = useObjectContext()

    return (
        <Stack direction={'row'} justifyContent={'space-between'}>
            <Stack direction={'row'} gap={'8px'}>
                <Icon
                    name={"Parking" as any}
                    iconColour={
                        past
                            ? ColoursObj.shades.shade2
                            : ColoursObj.core.secondary
                    }
                />
                <CardText variant="bodyBold">{parking_name}</CardText>
            </Stack>
        </Stack>
    )
}
